module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDMiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA0MyA0MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjEuNSIgY3k9IjIxIiByPSIxNiIgZmlsbD0iI0M0MjMyQSIvPgo8Y2lyY2xlIGN4PSIyMS41IiBjeT0iMjEiIHI9IjE4LjUiIHN0cm9rZT0iI0M0MjMyQSIgc3Ryb2tlLW9wYWNpdHk9IjAuMSIgc3Ryb2tlLXdpZHRoPSI1Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/todo-icon.svg
// module id = kzpc
// module chunks = 0